// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionPlanSummaryWidget_planSummary__IdtPS {
  padding: 14px;
  border: 1px solid #dce3e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);
}

.ActionPlanSummaryWidget_planSummary__IdtPS h2 {
  margin: 0 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #697782;
  font-size: 1rem;
}

.ActionPlanSummaryWidget_planSummary__IdtPS > p {
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: #687681;
  font-size: 0.86rem;
  text-align: center;
}

.ActionPlanSummaryWidget_planSummary__IdtPS > button {
  width: 100%;
  margin-top: 12px;
  padding: 8px 10px;
  border: 1px solid #d3dce3;
  border-radius: 7px;
  background: #fff;
  color: #455f78;
  cursor: pointer;
}

.ActionPlanSummaryWidget_planItem__Tb6ws {
  --action-color: var(--upcare-value-bienveillance);
  --action-soft: var(--upcare-value-bienveillance-soft);

  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  border: 1px solid #e2e7eb;
  border-left: 4px solid var(--action-color);
  border-radius: 8px;
  background: #fbfcfd;
  cursor: pointer;
  transition: border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;
}

.ActionPlanSummaryWidget_bienveillance__\\+lZ1L {
  --action-color: var(--upcare-value-bienveillance);
  --action-soft: var(--upcare-value-bienveillance-soft);
}

.ActionPlanSummaryWidget_engagement__zGQaB {
  --action-color: var(--upcare-value-engagement);
  --action-soft: var(--upcare-value-engagement-soft);
}

.ActionPlanSummaryWidget_faireEquipe__1WNp2 {
  --action-color: var(--upcare-value-faire-equipe);
  --action-soft: var(--upcare-value-faire-equipe-soft);
}

.ActionPlanSummaryWidget_respect__zHFiJ {
  --action-color: var(--upcare-value-respect);
  --action-soft: var(--upcare-value-respect-soft);
}

.ActionPlanSummaryWidget_planItem__Tb6ws:hover,
.ActionPlanSummaryWidget_planItem__Tb6ws:focus-visible {
  border-color: #c8d6df;
  border-left-color: var(--action-color);
  box-shadow: 0 4px 12px rgba(30, 55, 75, 0.09);
  outline: none;
}

.ActionPlanSummaryWidget_planItem__Tb6ws:active {
  transform: translateY(1px);
}

.ActionPlanSummaryWidget_typeBadge__0XNkV {
  align-self: flex-start;
  padding: 3px 7px;
  border: 1px solid var(--action-color);
  border-radius: 999px;
  background: var(--action-soft);
  color: #263746;
  font-size: 0.72rem;
}

.ActionPlanSummaryWidget_planItem__Tb6ws strong {
  font-size: 0.84rem;
}

.ActionPlanSummaryWidget_planItem__Tb6ws small {
  color: #697782;
}

.ActionPlanSummaryWidget_trainingMeta__DJUSe {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #e7ecef;
}

.ActionPlanSummaryWidget_capacity__OfomG {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #526773;
  font-size: 0.76rem;
  white-space: nowrap;
}

.ActionPlanSummaryWidget_capacity__OfomG > span:first-child {
  color: var(--action-color);
}

.ActionPlanSummaryWidget_registrationButton__yeP61 {
  border: 1px solid var(--action-color);
  border-radius: 999px;
  padding: 4px 9px;
  background: var(--action-color);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
}

.ActionPlanSummaryWidget_registrationButton__yeP61:hover {
  filter: brightness(0.92);
}

.ActionPlanSummaryWidget_registeredBadge__BGftE,
.ActionPlanSummaryWidget_fullBadge__T4tlf {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
}

.ActionPlanSummaryWidget_registeredBadge__BGftE {
  border: 1px solid var(--action-color);
  background: var(--action-soft);
  color: #263746;
}

.ActionPlanSummaryWidget_fullBadge__T4tlf {
  background: #edf0f2;
  color: #61717b;
}

.ActionPlanSummaryWidget_error__wTRNk {
  color: #b42318 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ActionPlan/ActionPlanSummaryWidget.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,qDAAqD;;EAErD,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,iDAAiD;EACjD,qDAAqD;AACvD;;AAEA;EACE,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,gDAAgD;EAChD,oDAAoD;AACtD;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;;AAEA;;EAEE,qBAAqB;EACrB,sCAAsC;EACtC,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".planSummary {\r\n  padding: 14px;\r\n  border: 1px solid #dce3e8;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 2px 8px rgba(30, 55, 75, 0.06);\r\n}\r\n\r\n.planSummary h2 {\r\n  margin: 0 0 14px;\r\n  padding-bottom: 10px;\r\n  border-bottom: 1px solid #697782;\r\n  font-size: 1rem;\r\n}\r\n\r\n.planSummary > p {\r\n  min-height: 90px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0;\r\n  color: #687681;\r\n  font-size: 0.86rem;\r\n  text-align: center;\r\n}\r\n\r\n.planSummary > button {\r\n  width: 100%;\r\n  margin-top: 12px;\r\n  padding: 8px 10px;\r\n  border: 1px solid #d3dce3;\r\n  border-radius: 7px;\r\n  background: #fff;\r\n  color: #455f78;\r\n  cursor: pointer;\r\n}\r\n\r\n.planItem {\r\n  --action-color: var(--upcare-value-bienveillance);\r\n  --action-soft: var(--upcare-value-bienveillance-soft);\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  padding: 10px;\r\n  border: 1px solid #e2e7eb;\r\n  border-left: 4px solid var(--action-color);\r\n  border-radius: 8px;\r\n  background: #fbfcfd;\r\n  cursor: pointer;\r\n  transition: border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;\r\n}\r\n\r\n.bienveillance {\r\n  --action-color: var(--upcare-value-bienveillance);\r\n  --action-soft: var(--upcare-value-bienveillance-soft);\r\n}\r\n\r\n.engagement {\r\n  --action-color: var(--upcare-value-engagement);\r\n  --action-soft: var(--upcare-value-engagement-soft);\r\n}\r\n\r\n.faireEquipe {\r\n  --action-color: var(--upcare-value-faire-equipe);\r\n  --action-soft: var(--upcare-value-faire-equipe-soft);\r\n}\r\n\r\n.respect {\r\n  --action-color: var(--upcare-value-respect);\r\n  --action-soft: var(--upcare-value-respect-soft);\r\n}\r\n\r\n.planItem:hover,\r\n.planItem:focus-visible {\r\n  border-color: #c8d6df;\r\n  border-left-color: var(--action-color);\r\n  box-shadow: 0 4px 12px rgba(30, 55, 75, 0.09);\r\n  outline: none;\r\n}\r\n\r\n.planItem:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.typeBadge {\r\n  align-self: flex-start;\r\n  padding: 3px 7px;\r\n  border: 1px solid var(--action-color);\r\n  border-radius: 999px;\r\n  background: var(--action-soft);\r\n  color: #263746;\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.planItem strong {\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.planItem small {\r\n  color: #697782;\r\n}\r\n\r\n.trainingMeta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  margin-top: 4px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid #e7ecef;\r\n}\r\n\r\n.capacity {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  color: #526773;\r\n  font-size: 0.76rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.capacity > span:first-child {\r\n  color: var(--action-color);\r\n}\r\n\r\n.registrationButton {\r\n  border: 1px solid var(--action-color);\r\n  border-radius: 999px;\r\n  padding: 4px 9px;\r\n  background: var(--action-color);\r\n  color: #fff;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n\r\n.registrationButton:hover {\r\n  filter: brightness(0.92);\r\n}\r\n\r\n.registeredBadge,\r\n.fullBadge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  min-height: 26px;\r\n  padding: 3px 9px;\r\n  border-radius: 999px;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.registeredBadge {\r\n  border: 1px solid var(--action-color);\r\n  background: var(--action-soft);\r\n  color: #263746;\r\n}\r\n\r\n.fullBadge {\r\n  background: #edf0f2;\r\n  color: #61717b;\r\n}\r\n\r\n.error {\r\n  color: #b42318 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"planSummary": `ActionPlanSummaryWidget_planSummary__IdtPS`,
	"planItem": `ActionPlanSummaryWidget_planItem__Tb6ws`,
	"bienveillance": `ActionPlanSummaryWidget_bienveillance__+lZ1L`,
	"engagement": `ActionPlanSummaryWidget_engagement__zGQaB`,
	"faireEquipe": `ActionPlanSummaryWidget_faireEquipe__1WNp2`,
	"respect": `ActionPlanSummaryWidget_respect__zHFiJ`,
	"typeBadge": `ActionPlanSummaryWidget_typeBadge__0XNkV`,
	"trainingMeta": `ActionPlanSummaryWidget_trainingMeta__DJUSe`,
	"capacity": `ActionPlanSummaryWidget_capacity__OfomG`,
	"registrationButton": `ActionPlanSummaryWidget_registrationButton__yeP61`,
	"registeredBadge": `ActionPlanSummaryWidget_registeredBadge__BGftE`,
	"fullBadge": `ActionPlanSummaryWidget_fullBadge__T4tlf`,
	"error": `ActionPlanSummaryWidget_error__wTRNk`
};
export default ___CSS_LOADER_EXPORT___;
